module.exports = __webpack_public_path__ + "img/3f70912ee364ae3d27be21150628090b.jpg";